import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29055c70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "anchor-container" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { style: {"color":"orangered"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Codemirror = _resolveComponent("Codemirror")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_anchor_link = _resolveComponent("a-anchor-link")!
  const _component_a_anchor = _resolveComponent("a-anchor")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_back_top = _resolveComponent("a-back-top")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_card, { bordered: false }, {
    default: _withCtx(() => [
      _createVNode(_component_a_tabs, {
        activeKey: _ctx.activeKey,
        "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeKey) = $event)),
        "tab-position": _ctx.tabPosition,
        onChange: _ctx.onTabChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_tab_pane, {
            key: "1",
            tab: "配置"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                model: _ctx.formState,
                "label-col": _ctx.labelCol,
                "wrapper-col": _ctx.wrapperCol
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "JSON Schema" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Codemirror, {
                        ref: "jsonCmRef",
                        value: _ctx.formState.json,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.json) = $event)),
                        options: _ctx.cmOptions,
                        height: 400,
                        border: "",
                        onChange: _ctx.onJsonChange
                      }, null, 8, ["value", "options", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { "wrapper-col": { span: 14, offset: 4 } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _ctx.onSubmit
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("确定")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "label-col", "wrapper-col"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, {
            key: "2",
            tab: "预览"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_a_anchor, { "target-offset": 40 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result, (item) => {
                      return (_openBlock(), _createBlock(_component_a_anchor_link, {
                        key: item.path,
                        href: '#' + item.path,
                        title: item.path,
                        onClick: _ctx.onAnchorClick
                      }, null, 8, ["href", "title", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result, (item) => {
                    return (_openBlock(), _createBlock(_component_a_col, {
                      key: item.path,
                      xl: 12,
                      md: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_card, { bordered: false }, {
                          title: _withCtx(() => [
                            _createElementVNode("a", {
                              style: {"height":"32px","font-weight":"bold"},
                              id: item.path
                            }, _toDisplayString(item.path), 9, _hoisted_2)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_Codemirror, {
                              value: item.content,
                              "onUpdate:value": ($event: any) => ((item.content) = $event),
                              options: _ctx.jbCmOptions,
                              height: 600,
                              border: ""
                            }, null, 8, ["value", "onUpdate:value", "options"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_back_top)
        ]),
        _: 1
      }, 8, ["activeKey", "tab-position", "onChange"]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.parseError), 1)
    ]),
    _: 1
  }))
}